// extracted by mini-css-extract-plugin
export default {"button":"WYRQy7","disabled":"E_cJvr","mobile-button":"Uiuycd","mobileButton":"Uiuycd","mobileFontSize":"pG2dmD"};